<app-truck-sidebar></app-truck-sidebar>
<div class="truck-owner-details">
  <div class="row" style="margin-bottom: -60px">
    <div class="truck-right-header">
      <span><img src="assets/img/location.svg" /> <a>Track</a></span>
      <span (click)="goToNotifications()" style="cursor: pointer;"> <img
          src="assets/img/bell.svg" />Notifications</span>
      <span>
        <div class="dropdown" matTooltip="Profile">
          <a mat-button [matMenuTriggerFor]="menu"><img class="header-profile"
              src="{{ profilePic ? profilePic : 'assets/img/profilesimg.svg' }}" />Hi,
            <span style="text-transform: capitalize">{{
              truckOwner?.username
              }}</span>
          </a>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="GoToProfile()">Profile</button>
            <div class="seperator"></div>
            <button mat-menu-item (click)="GoToOrders()">Orders</button>
            <div class="seperator"></div>
            <button mat-menu-item (click)="logout()">Logout</button>
          </mat-menu>
        </div>
      </span>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6 truck-owner-header-search">
      <div class="col-md-6"></div>
    </div>

    <div class="row add_route">
      <div class="breadcrumb">
        <a>Dashboard</a>
        <span>&gt;</span>
        <a>Profile</a>
        <span>&gt;</span>
        <a>Pre Order Setting</a>
        <a class="add_btn" style="text-decoration: underline; color: #0d9bfa" (click)="addRoutes()">Add</a>
      </div>
    </div>

    <div class="truck-owner-items to_container">
      <div class="row pickup_cities_container">
        <span class="section_title">Routes</span>
        <mat-divider class="section_divider"></mat-divider>
        <div [class.spinner]="loading"></div>

        <div class="row" *ngIf="!routesData.length && !loading">
          <h4 class="error_msg">No Records Found.</h4>
        </div>

        <div class="col-sm-3" *ngFor="let route of routesData">
          <mat-card class="truck-list">
            <div class="row truck_details_loc" style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              ">
              <div style="display: flex; align-items: center">
                <img src="../../../assets/img/location-payment.svg" alt="" class="location-icon" />
                <div class="places">
                  <p>{{ route.pickup_city.from_city_name }}</p>
                  <p class="truck-type">{{ route.truck_category_name }}</p>
                  <p>{{ route.dropoff_city.to_city_name }}</p>
                </div>
              </div>
              <div class="delete_preOrder">
                <img src="../../../assets/img/delete.svg" alt="Delete" class="delete-icon"
                  (click)="deletepreOrder(route)" />
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div class="pickup_cities_container">
        <span class="section_title">Pickup Cities</span>
        <mat-divider class="section_divider"></mat-divider>
        <div class="row" *ngIf="!pickupCitiesData.length && !loading">
          <h4 class="error_msg">No Records Found.</h4>
        </div>
        <div class="pickup_cities_row">
          <div class="pickup_city_card" *ngFor="let cities of pickupCitiesData">
            <img src="../../../assets/img/location-color.svg" class="location_icon" alt="Pickup Location" />
            <div class="city_details">
              <p class="city_name">{{ cities.pickup_city.from_city_name }}</p>
              <span class="truck_type">{{ cities.truck_category_name }}</span>
            </div>
            <img src="../../../assets/img/delete.svg" class="delete_icon" alt="Delete"
              (click)="deletepreOrder(cities)" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>